import { useEffect, useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { eur } from "../../lib/format";
import { LayoutGrid, Package, LogOut, ArrowUpRight, Users, CalendarCheck, Wallet, Inbox, ClipboardList, Newspaper } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex" style={{ background: "#F8F5F0", color: "#121212", fontFamily: "Manrope, sans-serif" }} data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-60 shrink-0 hidden md:flex flex-col" style={{ background: "#111111", color: "#F4F0EA" }}>
        <div className="p-6">
          <span className="font-heading text-2xl">Rokert<span style={{ color: "#B08D57" }}> Retreats</span></span>
          <p className="overline mt-1" style={{ color: "#B08D57" }}>Concierge Console</p>
        </div>
        <nav className="flex-1 px-3 space-y-1">
          <AdminNav to="/admin" end icon={LayoutGrid} label="Bookings" />
          <AdminNav to="/admin/leads" icon={ClipboardList} label="Enquiries" />
          <AdminNav to="/admin/guests" icon={Users} label="Guests" />
          <AdminNav to="/admin/chats" icon={Inbox} label="Inbox" />
          <AdminNav to="/admin/packages" icon={Package} label="Retreats" />
          <AdminNav to="/admin/blog" icon={Newspaper} label="Journal" />
        </nav>
        <div className="p-4 border-t border-white/10">
          <Link to="/" className="flex items-center gap-2 text-sm text-white/70 hover:text-white mb-3"><ArrowUpRight className="w-4 h-4" /> View site</Link>
          <button onClick={logout} className="flex items-center gap-2 text-sm text-white/70 hover:text-white" data-testid="admin-logout"><LogOut className="w-4 h-4" /> Sign out</button>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 min-w-0">
        <header className="px-6 md:px-10 py-6 flex items-center justify-between border-b" style={{ borderColor: "#E5E7EB" }}>
          <div>
            <h1 className="font-heading text-3xl">Concierge Dashboard</h1>
            <p className="text-sm" style={{ color: "#6B7280" }}>Welcome back, {user?.name}</p>
          </div>
        </header>

        {stats && (
          <div className="px-6 md:px-10 pt-8 grid grid-cols-2 lg:grid-cols-4 gap-4">
            <Stat icon={CalendarCheck} label="Total Bookings" value={stats.total_bookings} />
            <Stat icon={Users} label="Confirmed" value={stats.confirmed_bookings} />
            <Stat icon={Wallet} label="Revenue" value={eur(stats.revenue_eur)} />
            <Stat icon={Users} label="Guests" value={stats.total_guests} />
          </div>
        )}

        <div className="px-6 md:px-10 py-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

function AdminNav({ to, end, icon: Icon, label }) {
  return (
    <NavLink to={to} end={end} data-testid={`admin-nav-${label.toLowerCase()}`}
      className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl text-sm transition-colors ${isActive ? "bg-white/10 text-white" : "text-white/60 hover:text-white hover:bg-white/5"}`}>
      <Icon className="w-4 h-4" strokeWidth={1.6} /> {label}
    </NavLink>
  );
}

function Stat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border p-5 bg-white" style={{ borderColor: "#E5E7EB" }}>
      <div className="flex items-center gap-2 mb-3" style={{ color: "#6B7280" }}>
        <Icon className="w-4 h-4" strokeWidth={1.6} />
        <span className="text-xs uppercase tracking-wider">{label}</span>
      </div>
      <p className="font-heading text-3xl">{value}</p>
    </div>
  );
}
